import { Helmet } from "react-helmet-async"
import { HotelOtaBookings } from "../../../../HotelOtaBookings"
import { useParams } from "../../../../router-utils"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../../Auth"

export default function HotelBookingsPage() {
	const { hotelId } = useParams("/hotels/:hotelId")
	return (
		<>
			<Helmet>
				<title>Bookings | Hotel</title>
			</Helmet>
			<ForbidUnlessAuthorized permission={PERMISSIONS.VIEW_HOTEL_BOOKINGS}>
				<HotelOtaBookings hotelId={Number(hotelId)} />
			</ForbidUnlessAuthorized>
		</>
	)
}
